import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import type { AccountInfo } from '@azure/msal-browser';
import { resolveActiveAccount } from './active-account';
import { environment } from '../../../environments/environment';

// Shared check used by the admin route guard and the navigation link.
// Admin Part Coding matches named sign-in users on partCodingAdmins.
// Part Coding uses the separate partCodingUsers list.
export function userHasPartCodingAdminAccess(
	account: AccountInfo | null
): boolean {
	if (!account) return false;

	const username = account.username.trim().toLowerCase();
	return environment.msalConfig.users.partCodingAdmins.some(
		(admin) => admin.trim().toLowerCase() === username
	);
}

// Allows the Admin Part Coding route only for the configured approver;
// everyone else is redirected to the E-Filing page.
export const partCodingAdminGuard: CanActivateFn = (): boolean | UrlTree => {
	const msalService = inject(MsalService);
	const router = inject(Router);

	if (userHasPartCodingAdminAccess(resolveActiveAccount(msalService))) {
		return true;
	}

	return router.createUrlTree(['/']);
};
